<template>
	<div class="panel panel-primary">
		<div class="panel-heading">{{ heading }}</div>
		<div class="panel-body"><slot /></div>
	</div>
</template>
<script>
import BaseColumn from "../ui/layout/BaseColumn.vue";

export default {
	components: {BaseColumn},
	props: {
		heading: {
			type: String,
			required: true
		},
	}
}
</script>